<template>
  <div v-if="desconto" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes do Desconto</h4>
      <router-link to="/cadastros/descontos">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="Informações do Desconto">
        <p><strong>Descrição:</strong> {{ desconto.descricao || 'Não informado' }}</p>
        <p><strong>Desconto (%):</strong> {{ desconto.desconto !== null ? desconto.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + '%' : 'Não informado' }}</p>
        <p><strong>Status:</strong> {{ verificarAtivo(desconto.ativo) }}</p>
        <p><strong>Por:</strong> {{ desconto.por || 'Não informado' }}</p>
      </FormSection>

    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from '@/services/axios';
import FormSection from '@/components/Layout/FormSection.vue';

export default {
  components: { FormSection },
  data() {
    return {
      desconto: null,
    };
  },
  methods: {
    async carregarDetalhes() {
      try {
        const res = await axios.get(`/cadastros/descontos/${this.$route.params.id}`);
        this.desconto = res.data;
      } catch (error) {
        console.error('Erro ao carregar detalhes do desconto:', error.response?.data || error);
      }
    },
    verificarAtivo(valor) {
      if (valor === undefined || valor === null) return 'Não informado';
      return valor ? 'Ativo' : 'Inativo';
    },
    formatarData(data) {
      if (!data) return 'Não informado';
      const d = new Date(data);
      return d.toLocaleString('pt-BR');
    },
  },
  mounted() {
    this.carregarDetalhes();
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.form-content {
  margin-top: 1.5rem;
}
button.btn-sm {
  padding: 6px 12px;
}
</style>
